export const BlockerModalIds = {
	termsAndConditionModal: {
		state: true,
	},
	privacyPolicyModal: {
		state: true,
	},
};
